var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImageDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6666 20.75C18.6666 19.2381 18.6666 18.4822 18.48 17.8671C18.0599 16.4822 16.9761 15.3984 15.5912 14.9783C14.976 14.7917 14.2201 14.7917 12.7082 14.7917H7.29159C5.77973 14.7917 5.02379 14.7917 4.40868 14.9783C3.02374 15.3984 1.93996 16.4822 1.51984 17.8671C1.33325 18.4822 1.33325 19.2381 1.33325 20.75M14.8749 6.125C14.8749 8.81739 12.6923 11 9.99992 11C7.30753 11 5.12492 8.81739 5.12492 6.125C5.12492 3.43261 7.30753 1.25 9.99992 1.25C12.6923 1.25 14.8749 3.43261 14.8749 6.125Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageDefault);
export default __webpack_public_path__ + "static/media/image-default.08d82228b308d335cfe3c430fe51e592.svg";
export { ForwardRef as ReactComponent };